"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var number_schema_1 = __importStar(require("./number.schema"));
exports.createBaseNumberSchema = number_schema_1.createBaseNumberSchema;
exports["default"] = number_schema_1["default"];
//# sourceMappingURL=index.js.map